export default "__VITE_ASSET__Dp$OZvxy__"